// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar-imgBackground-lZO88 {
	background-color: var(--secondary-gray-bg);
}`, "",{"version":3,"sources":["webpack://./src/components/Avatar/Avatar.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;AAC3C","sourcesContent":[".imgBackground {\n\tbackground-color: var(--secondary-gray-bg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgBackground": `Avatar-imgBackground-lZO88`
};
module.exports = ___CSS_LOADER_EXPORT___;
